// extracted by mini-css-extract-plugin
module.exports = {"photoPost":"UserPhotoPost_photoPost__3Oxxj","file":"UserPhotoPost_file__2WAw8","preview":"UserPhotoPost_preview__3N9QR"};